module.exports = __webpack_public_path__ + "static/molly-399x250-eb286f0614ab3c18e56e317282bb72e7.png";